var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountMenuHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home-icon",
    transform: "translate(-1407 -2684)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4791",
    "data-name": "Rectangle 4791",
    width: 24,
    height: 24,
    transform: "translate(1407 2684)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons_Home_Line",
    "data-name": "icons/Home/Line",
    transform: "translate(1408.514 2684.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M9.479,1.739l.007,0,.008,0,3.84,2.3,1.326.8v9.512c0,.511,0,.791-.018.992l0,.023-.023,0c-.2.016-.481.018-.992.018H5.347c-.511,0-.791,0-.992-.018l-.023,0,0-.023c-.016-.2-.018-.481-.018-.992V4.842l1.321-.8Zm-4.734.829L.419,5.163a.862.862,0,1,0,.887,1.479l1.281-.769v8.48a4.285,4.285,0,0,0,.188,1.818,1.725,1.725,0,0,0,.754.754,4.285,4.285,0,0,0,1.818.188h8.279a4.285,4.285,0,0,0,1.818-.188,1.724,1.724,0,0,0,.754-.754,4.285,4.285,0,0,0,.188-1.818V5.874l1.281.769a.862.862,0,0,0,.887-1.479l-4.331-2.6-3.312-2c-.241-.145-.426-.256-.582-.34Q10.273.2,10.217.172A1.586,1.586,0,0,0,9.857.04a1.725,1.725,0,0,0-.742,0,1.588,1.588,0,0,0-.36.132Q8.7.2,8.645.228c-.157.084-.342.2-.583.341Z",
    transform: "translate(1 2.155)",
    fill: "#6b6b95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M3.449,6.036V2.587a.862.862,0,0,0-1.725,0V6.036ZM2.587,0A2.587,2.587,0,0,0,0,2.587V7.761H5.174V2.587A2.587,2.587,0,0,0,2.587,0Z",
    transform: "translate(7.899 11.507)",
    fill: "#6b6b95",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountMenuHome);
export default __webpack_public_path__ + "static/media/accountMenuHome.59ec9ad9fdb2fb719e0d9b176e508f41.svg";
export { ForwardRef as ReactComponent };